"use strict";
import axios from "axios";
import { getPastDateAsString } from "./DateService";
import { getAuthHeaders } from "./UserTokenService";

// const base_route = `premia/tba/spd_records`
const base_route = `gimo/spd`;

export const getSpdFailedRecords = async (payload) => {
  if (payload.start_date == undefined || payload.start_date == null)
    payload = { ...payload, start_date: getPastDateAsString(0) };
  if (payload.end_date == undefined || payload.end_date == null)
    payload = { ...payload, end_date: getPastDateAsString(0) };

  const response = await axios.post(
    `${base_route}/failed-entries`,
    payload,
    getAuthHeaders()
  );

  return response;
};

export const getSpdHistories = async (payload) => {
  // default to 3 days ago
  if (payload.start_date == undefined || payload.start_date == null)
    payload = { ...payload, start_date: getPastDateAsString(3) };
  if (payload.end_date == undefined || payload.end_date == null)
    payload = { ...payload, end_date: getPastDateAsString(0) };

  const response = await axios.post(
    `${base_route}/histories`,
    payload,
    getAuthHeaders()
  );

  return response;
};

export const createSpdRecord = async (spd_record_dto) => {
  const response = await axios.post(
    `${base_route}/repush`,
    spd_record_dto,
    getAuthHeaders()
  );

  return response;
};
